import React, { useMemo, useState } from 'react';
import { TDirectorInfo } from '../../../types';
import BreakdownModal from './BreakDownModal';
import Button2 from '../../global/Button2';

type TProps = {
  shareholders: TDirectorInfo[];
  currentShareholder: number;
  setShareholders: React.Dispatch<React.SetStateAction<TDirectorInfo[]>>;
  displayErrorMessage: (errorText: string, variable: string) => JSX.Element | undefined;
  submitting: boolean;
};
export const SharesProgressBar = ({
  currentShareholder,
  setShareholders,
  shareholders,
  displayErrorMessage,
  submitting,
}: TProps) => {
  const [showModal, setShowModal] = useState(false);
  const [vvv, setVvv] = useState('');
  const currentShares = shareholders?.reduce(
    (acc, shareholder) => acc + Number(shareholder.share ?? 0),
    0,
  );

  return (
    <>
      <div
        className={[
          'sl:flex gap-4 mr-[4vw]',
          submitting && !shareholders?.[currentShareholder]?.share ? 'items-center' : 'items-end',
        ].join(' ')}
      >
        <div className='sl:w-[15vw] mb-[25px]'>
          <div className='text-[#212121] text-xs mb-1 font-[600] sl:font-[400] text-[14px] sl:text-xs'>
            How many shares are alloted to this shareholder?
          </div>
          {Number(vvv) - Number(shareholders?.[currentShareholder]?.share ?? 0) >
            100 - currentShares && (
            <div className='text-[10px] text-[red]'>{`Total shares cannot exceed 100%`}</div>
          )}
          <div className='flex w-full items-center'>
            <div className='border-[#DDDDDD] border-[1px] w-[20%] text-center py-1 px-2 bg-[#E8EDF1] h-[45px] text-[rgba(118, 131, 150, 0.89)] text-[23px]'>
              %
            </div>
            <input
              className='sl:mr-2 border-[#DDDDDD] border-[1px] w-[80%] outline-none p-2 h-[45px]'
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setVvv(e.target.value);
                if (
                  Number(e.target.value) - Number(shareholders?.[currentShareholder]?.share ?? 0) <=
                  100 - currentShares
                ) {
                  const shareholders_ = shareholders?.[currentShareholder]
                    ? shareholders
                    : [...shareholders, {} as TDirectorInfo];
                  const shareholder = shareholders_?.map((shareholder, ind) => {
                    if (currentShareholder === ind) {
                      return {
                        ...shareholder,
                        share: e.target.value,
                      };
                    }
                    return shareholder;
                  });
                  setShareholders(shareholder);
                }
              }}
              value={shareholders?.[currentShareholder]?.share ?? ''}
            />
            <div className='hidden sl:block'>=</div>
          </div>
          {displayErrorMessage(
            'Shares cannot be empty',
            shareholders?.[currentShareholder]?.share ?? '',
          )}
        </div>

        <div className='sl:w-[14vw] mb-[25px]'>
          <div className='text-[#212121] text-xs font-[600] sl:font-[400] mb-1 text-[14px] sl:text-xs'>
            Equivalent value of shares
          </div>
          <div className='flex w-full'>
            <div className='border-[#DDDDDD] border-[1px] w-full rounded-[2px] p-2 bg-[#E8EDF1] h-[45px]'>
              {shareholders?.[currentShareholder]?.share
                ? Number(shareholders?.[currentShareholder]?.share) * 10000
                : ''}
            </div>
          </div>
        </div>

        <div className='sl:flex items-end mb-[25px]'>
          <div className='sl:w-[14vw]'>
            <div className='text-[#028789] text-xs mb-1 w-full font-[600] sl:text-center sl:font-[400] text-[14px] sl:text-xs'>{`${
              100 - currentShares
            }% Shares remaining`}</div>
            <div className='flex w-full'>
              <div
                style={{ width: `${currentShares}%` }}
                className='w-full bg-[#E2AB19] h-[45px]'
              ></div>
              <div
                style={{ width: `${100 - currentShares}%` }}
                className='w-full bg-[#028789] h-[45px] sl:mr-2'
              ></div>
            </div>
          </div>

          <Button2
            type='submit'
            theme='tertiary'
            className='!px-2 !gap-1 md:px-3 py-[10px] text-[11px] inline-block mt-2 sl:mt-0'
            size='sm'
            underline={false}
            onClick={() => setShowModal(true)}
          >
            VIEW BREAKDOWN
          </Button2>
        </div>
      </div>

      <BreakdownModal
        shareholders={shareholders}
        title={'SHARES BREAKDOWN'}
        setShowModal={setShowModal}
        showModal={showModal}
        sharesAllocated={currentShares}
      />
    </>
  );
};
